import React from "react";
import { pages } from "@/routes/pageImports";
import RouteCondition from "@/helper/HrRouteCondition";

// Utility function to create auth routes
const createAuthRoute = (path, Component) => ({
  path,
  element: <RouteCondition type="auth" Component={Component} />,
});

const creatOnboardingRoute = (path, Component) =>({
  path,
  element: <RouteCondition type="onboarding" Component={Component} />
})

// Utility function to create private routes for Human Resource
const createPrivateRoute = (path, Component) => ({
  path,
  element: (
    <RouteCondition
      type={"private"}
      userRole="HUMAN_RESOURCE"
      Component={Component}
    />
  ),
});

// Main function to dynamically define Human Resource routes
const HrRoutes = () => {

  // Define public (auth) routes for Human Resource
  const hrAuthRoutes = [
    createAuthRoute("/hr/login", pages.NewLoginPage),
    createAuthRoute("/hr/register", pages.HrSignupPage),
    createAuthRoute("/hr/otp", pages.CommonOtpPage),
    createAuthRoute("/hr/create-password", pages.CreatePassPage),
  ];

  const hrOnboardingRoutes =  [
    creatOnboardingRoute("/hr/company-info1", pages.HrCompanyInfo1Page),
    creatOnboardingRoute("/hr/company-info2", pages.HrCompanyInfo2Page),
    creatOnboardingRoute("/hr/company-info3", pages.HrCompanyInfo3Page),
    // creatOnboardingRoute("/hr/company-info4", pages.HrCompanyInfo4Page),
    creatOnboardingRoute("/hr/company-address", pages.HrCompanyAddressPage),
    creatOnboardingRoute("/hr/contact-info", pages.HrContactPage),
  ]

  // Define private routes for Human Resource
  const hrPrivateRoutes = [
    createPrivateRoute("/hr/*", pages.HrDashboardIndex),
    createPrivateRoute("/hr/edit-profile", pages.EditCompanyProfile),
    createPrivateRoute("/hr/settings/*", pages.SettingIndex),
  ];

  return { hrAuthRoutes, hrPrivateRoutes, hrOnboardingRoutes };
};

export default HrRoutes;
